(function () {
    'use strict';

    angular.module("imApp").factory("categoryListMainService", ['$ihttp', function ($ihttp) {
        let service = {
            listMainCategories: function (parms) {
                return $ihttp.post({
                    method: 626,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
